import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 66,
	height: 54,
	viewBox: "0 0 66 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M42 15L24 15V9L42 9V15Z",
			fill: "#BDBDBD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
			fill: "#BDBDBD"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M60 6H48V18H60V6ZM48 0C44.6863 0 42 2.68629 42 6V18C42 21.3137 44.6863 24 48 24H60C63.3137 24 66 21.3137 66 18V6C66 2.68629 63.3137 0 60 0H48Z",
			fill: "#BDBDBD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42 36C42 32.6863 44.6863 30 48 30H60C63.3137 30 66 32.6863 66 36V48C66 51.3137 63.3137 54 60 54H48C44.6863 54 42 51.3137 42 48V36Z",
			fill: "#BDBDBD"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30 42V12H36V39H45V45H33C31.3431 45 30 43.6569 30 42Z",
			fill: "#BDBDBD"
		})
	]
});
export default SvgLogic;
